"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _CreditMenu = _interopRequireDefault(require("./CreditMenu"));

require("../styles/_credits-info.scss");

function hasTeamsCredits(a) {
  var b = a.teams,
      c = a.creditType;
  return "TEAM" === c && b && b.length;
}

function getCreditsTotal(a) {
  var b = a.teams,
      c = a.creditBalance,
      d = a.creditType;
  return hasTeamsCredits({
    creditType: d,
    teams: b
  }) ? b.reduce(function (a, b) {
    var c = b.creditBalance;
    return c ? {
      balance: c.balance + a.balance,
      rolloverBalance: c.rolloverBalance + a.rolloverBalance
    } : a;
  }, {
    balance: 0,
    rolloverBalance: 0
  }) : c;
}

function CreditsInfo(a) {
  var b = a.isUnlimited,
      c = a.creditBalance,
      d = a.creditType,
      e = a.teams,
      f = void 0 === e ? [] : e;
  if (!d) return null;
  var g = (0, _react.useCallback)(function () {
    return getCreditsTotal({
      teams: f,
      creditBalance: c,
      creditType: d
    });
  }, [f, c, d]),
      h = g(),
      i = h.balance + h.rolloverBalance,
      j = hasTeamsCredits({
    creditType: d,
    teams: f
  });
  return _react["default"].createElement(_uiKit.MenuButton, {
    id: "credits-info",
    buttonProps: {
      prefix: !j && b ? "unlimited" : void 0,
      children: "".concat(!j && b ? "" : i, " credits remaining")
    }
  }, _react["default"].createElement(_CreditMenu["default"], {
    creditBalance: c,
    isUnlimited: b,
    creditType: d,
    teams: f,
    hasTeamsCredits: !!j
  }));
}

var _default = (0, _react.memo)(CreditsInfo);

exports["default"] = _default;